import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useLocation } from 'react-router-dom';
import { setStripeKey } from "../utilities/httpRequest";
import TextButton from '../components/TextButton';


// Chargez Stripe


const stripePromise = loadStripe(process.env.REACT_APP_STRIPEKEY); // Remplacez par votre clé publique Stripe

const PaymentPage = () => {
    const [sessionId, setSessionId] = useState(null);

    //Récuperation de l'id
    const location = useLocation();
    
    
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = parseInt(queryParams.get('id'), 10) || "";
        setStripeKey(id, setSessionId);

    }, [location.search])

    const handleClick = async () => {
        // Créez une session de paiement
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
            sessionId,
        });

        if (error) {
            console.error('Erreur Stripe', error);
        }
    };

    return (
        <div>
            {sessionId ? (
                <TextButton className="" role="link" onClick={handleClick} text="PAYER MAINTENANT"/>
            ) : (
                <p id="alert-window-text" style={{whiteSpace: "pre-line"}}>Chargement...</p>
            )}
        </div>
    );
};

export default function Payment() {

    return (
        <div className="popup-bg" id="alert-window">
            <div className="popup-window bg-white p-5">
                <img className="h-20 object-contain" alt="logo" style={{marginBottom:20}} src="/iconslimsvet/logo.png">
                </img>
                    <Elements stripe={stripePromise}>
                        <PaymentPage />
                    </Elements>
            </div>
        </div>
    )

}